import { HttpInterceptorFn } from '@angular/common/http';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { TokenService } from '../services/token.service';


export const authClinicInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const tokenService = inject(TokenService);

  const request_url = req.url;
  const excludedRoutes = ['auth/customer/create'];
  const isExcludedRequest = excludedRoutes.some(route => request_url === route);

  /**
   * El registro de cliente (SPEC-030) es un flujo publico y AUTOCONTENIDO: se autentica
   * con el header x-registro-token, nunca con Bearer. Ademas usa el 401 como parte del
   * contrato (token de registro vencido, codigo sin verificar, clave incorrecta en el
   * login), y el redirect de abajo desmontaba el wizard antes de que el usuario llegara
   * a leer el error. Por eso queda fuera del interceptor entero, no solo del header.
   */
  const esRegistroCliente = request_url.includes('/registro-cliente/');
  if (esRegistroCliente) return next(req);

  if (!isExcludedRequest) {
    const accessToken = tokenService.getToken();
    if (accessToken) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    }
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // Sesion expirada: al marketplace (publico), no a la ruta 'Unauthorized' que no existe.
        router.navigate(['/marketplace']);
      }
      return throwError(error);
    })
  );
};
